export const LOAD_BOARD = "LOAD_BOARD";
export const PLACE_BOAT = "PLACE_BOAT";
export const PLAYER_READY = "PLAYER_READY";
export const SELECT_BOAT = "SELECT_BOAT";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const CHANGE_NICK = "CHANGE_NICK";

export const SHOOT = "SHOOT";
export const HIT = "HIT";

export const JOIN_GAME = "JOIN_GAME";
export const GAME_PLACEMENT_STARTS = "GAME_PLACEMENT_STARTS";
